import { render } from "./BottomShareIcons.vue?vue&type=template&id=988bb2b4&scoped=true"
import script from "./BottomShareIcons.vue?vue&type=script&lang=js"
export * from "./BottomShareIcons.vue?vue&type=script&lang=js"

import "./BottomShareIcons.vue?vue&type=style&index=0&id=988bb2b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988bb2b4"]])

export default __exports__